import React from 'react'
import ModalV4 from "../../../app/ui/modal/v4/v4"

import ItemViewTop from "../../../layout/top/item-view-top/item-view-top"
import ProjectUserIcon from "./components/project-user-icon/project-user-icon"
import UI5MenuItem from "../../gd-components/menu/ui5-menu/ui5-menu-item"
import ModalUserDefault from "./components/views/default-view"

// @ts-ignore
import ModalProjectUserActions from "./actions/actions"
// @ts-ignore
import ModalUserConfirm from "./components/views/confirm-view"
// @ts-ignore
import ModalUserReassign from "./components/views/reassign-view"

type Props = {
    params: any
}

class ModalUserView extends ModalV4 {

    private actions: ModalProjectUserActions

    constructor(props: Props) {
        super(props);

        this.state = {
            view                : this.props.params.reassignResult ? 'reassign-delete' : 'default',
            reasonCantDelete    : '',
            itemsToReassign     : this.props.params.reassignResult,
            reassignCallback    : null
        }

        this.actions = new ModalProjectUserActions(this.props.params, this.update, this.reassignItems)

        if (this.props.params.reassignResult) {
            this.actions.onReassignDone = this.props.params.onReassignDone
        }
    }

    update = (callback: callback) => {this.forceUpdate(callback)}

    onDeleteClick = () => {
        const {canDelete, reasonCantDelete} = this.actions.checkDelete();

        if (!canDelete) {
            this.setState({
                view: 'confirm',
                reasonCantDelete: reasonCantDelete
            });
        } else {
            this.actions.onDeleteConfirmed();
        }
    }

    onCancel = () => {
        this.setState({
            view: 'default',
        });
    }

    reassignItems = (view: string, itemsToReassign: any) => {
        this.setState({
            view            : view,
            itemsToReassign : itemsToReassign
        })
    }

    renderMain() {
        switch (this.state.view) {
            case 'confirm':
                return (
                    <ModalUserConfirm projectUser={this.props.params.projectUser}
                                      reasonCantDelete={this.state.reasonCantDelete}
                                      onCancel={this.onCancel}/>
                )

            case 'reassign-access':
            case 'reassign-delete':
                return (
                    <ModalUserReassign reassignType={this.state.view}
                                       projectUser={this.props.params.projectUser}
                                       itemsToReassign={this.state.itemsToReassign}
                                       actions={this.actions}/>
                )

            default:
                return (
                    <ModalUserDefault projectUser={this.props.params.projectUser}
                                      projectUsers={this.props.params.projectUsers}
                                      actions={this.actions}/>
                )
        }
    }

    render() {

        const  menuItemAccess = {
            id          : 'default',
            icon        : 'ii5-information',
            label       : 'Project access',
            onClick     : this.onCancel
        }

        const  menuItemDelete = {
            id          : 'delete',
            icon        : 'i5-trash-alt',
            label       : 'Delete user',
            className   : "red",
            onClick     : this.onDeleteClick
        }

        const title = gd.spaces.workspaces.getByProjectId(this.props.params.projectUser.projectId) ? 'Workspace user' : 'Project user'

        return (
            <div className="v4-container placement-middle ui5-iv view-project-user" onClick={this.stopPropagation}>
                <ItemViewTop title={title} onCloseClick={this.closeModal}/>

                <div className="iv-left-column">
                    <ProjectUserIcon projectId={this.props.params.projectUser.projectId} userId={this.props.params.projectUser.userId}/>

                    <div className="ui5-menu p-t-0">
                        <UI5MenuItem item={menuItemAccess} selectedId={this.state.view}/>
                        {this.props.params.projectUser.acl.canDelete &&
                            <UI5MenuItem item={menuItemDelete} selectedId={this.state.view}/>
                        }

                    </div>
                </div>

                {this.renderMain()}
            </div>
        )
    }
}

module.exports = ModalUserView;
